module.exports = __webpack_public_path__ + "img/jdjy.472a7bd7.png";